export default [
  { name: 'England', code: 'england' },
  { name: 'Wales', code: 'wales' },
  { name: 'Scotland', code: 'scotland' },
  { name: 'Northern Ireland', code: 'northern-ireland' },
];
